export default __webpack_public_path__ + "static/media/Roboto-Light.f333a74a.eot";